module.exports = __webpack_public_path__ + "img/ly.dd144fe2.svg";